import { VCombobox } from 'vuetify/lib'

export default {
  extends: VCombobox,

  methods: {
    selectItem(item) {
      this.setMenuIndex(-1)
      this.$emit("selection", item)
    },

    onEnterDown(e) {
      e.preventDefault()

      if (this.getMenuIndex() == -1) {
        this.isMenuActive = false
        this.$emit("submit")
      }
    },
  }
}
